import React from 'react';
import { Paper, Title, Text, Avatar, Group, Badge, Divider, Button } from '@mantine/core';
import { ChevronRight } from 'lucide-react';
interface ListItemProps {
  title: string;
  subtitle: string;
  date: string;
  status?: string;
  icon: React.ReactNode;
  type?: 'contact' | 'campaign';
}
function ListItem({
  title,
  subtitle,
  date,
  status,
  icon,
  type = 'contact'
}: ListItemProps) {
  const bgColor = type === 'contact' ? '#E3F2FD' : '#E8F5E9';
  const iconColor = type === 'contact' ? '#003d91' : '#00A86B';
  return <>
      <div className="flex items-center justify-between py-3" data-id="element-106">
        <Group gap="sm" data-id="element-107">
          <Avatar radius="xl" style={{
          backgroundColor: bgColor,
          color: iconColor
        }} data-id="element-108">
            {icon}
          </Avatar>
          <div data-id="element-109">
            <Text fw={500} data-id="element-110">{title}</Text>
            <Text size="sm" c="dimmed" data-id="element-111">
              {subtitle}
            </Text>
          </div>
        </Group>
        <div className="flex flex-col items-end gap-1" data-id="element-112">
          {status && <Badge color={status === 'Concluída' ? 'green' : status === 'Em andamento' ? 'yellow' : 'blue'} variant="light" data-id="element-113">
              {status}
            </Badge>}
          <Text size="xs" c="dimmed" data-id="element-114">
            {date}
          </Text>
        </div>
      </div>
      <Divider data-id="element-115" />
    </>;
}
interface RecentListProps {
  title: string;
  items: Array<ListItemProps>;
  onViewAll: () => void;
}
export function RecentList({
  title,
  items,
  onViewAll
}: RecentListProps) {
  return <Paper radius="lg" p="md" withBorder data-id="element-116">
      <div className="flex items-center justify-between mb-md" data-id="element-117">
        <Title order={4} data-id="element-118">{title}</Title>
        <Button size="sm" rightSection={<ChevronRight size={16} data-id="element-120" />} onClick={onViewAll} radius="lg" styles={{
        root: {
          backgroundColor: 'transparent',
          border: '1px solid #0047AB',
          color: '#0047AB',
          height: '48px',
          '&:hover': {
            backgroundColor: '#E3F2FD'
          }
        }
      }} data-id="element-119">
          Ver todos
        </Button>
      </div>
      <div data-id="element-121">
        {items.map((item, index) => <ListItem key={index} {...item} data-id="element-122" />)}
      </div>
    </Paper>;
}